import React from 'react';
import PropTypes from 'prop-types';
// import TextTruncate from 'react-text-truncate';
import LightBulb from 'assets/icons/icon-bulb.svg';
import './Notes.scss';
import IconError from 'assets/icons/icon-error.svg';

const Notes = props => (
  <div className="notes">
    <img src={props.isInfo ? LightBulb : IconError} alt="Information" />
    {/* <TextTruncate
      line={3}
      element="span"
      truncateText="..."
      text={props.msg}
      // textTruncateChild={<a href="#">Read on</a>}
    /> */}
    {props.msg}
  </div>
);

Notes.propTypes = {
  /** message */
  msg: PropTypes.node,
  /** isInfo */
  isInfo: PropTypes.bool,
};

Notes.defaultProps = {
  msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  isInfo: true,
};

export default Notes;
